import { domain } from 'modules/data';
import { useMemo } from 'react';
import bemFactory from 'react-bem-factory';

import { ContactListItemProps } from './ContactListItem.types';

export const useContactListItemQa = (integrationType: ContactListItemProps['integrationType']) => {
    return useMemo(() => {
        let qa;

        switch (integrationType) {
            case domain.IntegrationType.Xero:
                qa = bemFactory.qa('form-dropdown-editor-list-item');
                break;

            case domain.IntegrationType.QBooks:
            case domain.IntegrationType.NetSuite:
                qa = bemFactory.qa('reqf-dropdown-editor-list-item');
                break;
        }

        return {
            qaWrap: qa,
        };
    }, [integrationType]);
};
